import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { MapPin } from "lucide-react";

const F = (p) => `${process.env.REACT_APP_BACKEND_URL}/api/files/${p}`;
const t = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta", dateStyle: "medium", timeStyle: "short" }) : "-");

export const CustomerVisits = ({ cid }) => {
  const [v, setV] = useState(null);
  useEffect(() => { api.get(`/sales/customer-visits/${cid}`).then(({ data }) => setV(data)).catch(() => setV([])); }, [cid]);
  if (!v) return null;
  return (
    <div data-testid="cust-visits">
      <div className="text-xs text-slate-500 mb-1 flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />Riwayat kunjungan sales ({v.length})</div>
      {!v.length && <p className="text-xs text-slate-400">Belum ada kunjungan sales.</p>}
      <div className="space-y-2 max-h-72 overflow-y-auto">{v.map((x) => (
        <div key={x.id} className="rounded-lg border border-slate-200 p-2 text-xs" data-testid={`cust-visit-${x.id}`}>
          <div className="flex flex-wrap gap-2"><b>{t(x.at)}</b><span>{x.name}</span>{x.purpose && <span className="px-2 rounded-full bg-slate-100">{x.purpose}</span>}{x.outcome_label && <span className="px-2 rounded-full bg-emerald-50 text-emerald-800">{x.outcome_label}</span>}</div>
          <div className="text-slate-600 mt-0.5">PIC {x.pic || x.contact_name || "-"} {x.pic_phone || x.phone || ""} · OUT {x.result_at ? t(x.result_at) : "belum"} · {x.km} km {formatIDR(x.transport)}{x.estimate ? ` · estimasi ${formatIDR(x.estimate)}` : ""}</div>
          {x.result_notes && <div className="mt-0.5">{x.result_notes}</div>}
          <div className="flex gap-1 mt-1">{[...(x.photos || []), ...(x.result_photos || [])].map((p) => <a key={p} href={F(p)} target="_blank" rel="noreferrer"><img src={F(p)} alt="foto kunjungan" className="w-12 h-12 rounded object-cover border border-slate-200" /></a>)}</div>
        </div>))}</div>
    </div>
  );
};
